export const HORIZONTAL_ALIGNMENT = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
}
